<script setup lang="ts">
import { useVueI18n } from '../../locales'
import MediaLibraryFilePicker from './MediaLibraryFilePicker.vue'
import { UploadCloud02Icon } from '@gohighlevel/ghl-icons/24/outline'
import { UITextSmRegular, UITextXsRegular } from '@gohighlevel/ghl-ui'
const t = useVueI18n()

const props = defineProps({
  image: {
    type: String,
    default: '',
  },
})
</script>

<template>
  <MediaLibraryFilePicker
    triggerClassName="custom-ui-file-upload mb-2"
    previewClassName="w-[120px] mb-4"
    :image="props.image"
  >
    <template #trigger>
      <div
        class="flex items-center justify-center text-center flex-col gap-2 border border-1 rounded-lg px-2 py-4 max-w-sm mb-4 cursor-pointer"
      >
        <div>
          <div
            class="bg-gray-100 rounded-full w-6 h-6 flex items-center justify-center border-[6px] border-gray-50"
          >
            <UploadCloud02Icon class="w-4 h-4" />
          </div>
        </div>
        <div>
          <UITextSmRegular class="font-medium text-primary-700">{{
            t('common.clickToUpload')
          }}</UITextSmRegular>

          <UITextXsRegular>{{
            t('common.imageUploadFormats')
          }}</UITextXsRegular>
        </div>
      </div>
    </template>
  </MediaLibraryFilePicker>
</template>
